<template>
  <div class="com-loading" @touchmove.prevent>
    <div class="loading-circle spin-round"></div>
  </div>
</template>

<script>
export default {
  name: 'cpt_loading',
}

</script>

<style lang="less">
.com-loading {
  position: absolute;
  z-index: 3000;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  .loading-circle {
    width: 44px;
    height: 44px;
    border: 2px solid #DCE1E6;
    border-top-color: #64696E;
    border-radius: 100%;
  }
  .spin-round {
    animation: spin-round 0.9s infinite linear;
  }
  @keyframes spin-round {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>